import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const SettingsList = styled.div`
    display: grid;
    grid-template-columns: minmax(160px, auto) 1fr;
`;

export const SettingRow = styled.div`
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: subgrid;
    padding: 0.6rem 0;
    border-bottom: 1px solid ${tokens.border.default};
`;

export const SettingName = styled.div<{ $indented?: boolean }>`
    font-weight: 500;
    display: flex;
    align-items: center;
    padding-right: 1rem;
    ${({ $indented }) => ($indented ? 'padding-left: 1.6rem;' : '')}
`;

export const SettingValue = styled.div`
    display: flex;
    align-items: center;
    overflow-x: hidden;
`;

export const HelperText = styled.div`
    grid-column: 1 / -1;
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: ${tokens.text.secondary};
    padding-top: 0.4rem;
`;

export const SectionHeading = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    padding-bottom: 1.6rem;
`;

export const SectionTitle = styled.h2`
    font-size: 2rem;
    font-weight: 500;
    line-height: 2.6rem;
    margin: 0;
`;

export const SectionDescription = styled.p`
    font-size: 1.4rem;
    line-height: 1.8rem;
    color: ${tokens.text.primary};
    margin: 0;
`;
